import React, { useEffect } from "react";
import { Row, Col } from "../../components/Layout";
import { useSelector, useDispatch } from "react-redux";
import { useMemo, useState } from "react";
import _ from "lodash";
import { Alert } from "../../components/Alert";
import { toast } from "react-toastify";
import * as providerActionCreators from "../../load-build/orders/actions";
import { bindActionCreators } from "redux";
import { log } from "../../Helper";
import { callEndDateAPI } from "./api";
import LoaderComponent from "../../LoaderComponent/LoaderComponent";
import { Button, Typography } from "@deere/fuel-react";
import AlertTitle from '@mui/material/AlertTitle';

const Provider = (props) => {
  const [selectedProviderId, setProviderId] = useState(0);
  const [selecetdEndDate, setEndDate] = useState(0);
  const [openLoader, setOpenLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState([]);
  const [errorHeader, setErrorHeader] = useState("");
  const [isShowAlert, setShowAlert] = useState(false);
  const [accessibilityLabel, setAccessibilityLabel] = useState("");
  const [alertVariant, setAlertVariant] = useState("");
  const { load } = bindActionCreators(providerActionCreators, useDispatch());

  //load all providers
  useEffect(function () {
    load();
  }, []);

  let minDate = new Date().toISOString().slice(0, 10);

  const onProviderChange = (providerValue) => {
    setProviderId(providerValue);
  };

  const onDateChange = (event) => {
    setEndDate(event.target.value)
  }

  const providerList = useSelector((storeState) => storeState.getProviderList);

  const pl = useMemo(
    () =>
      providerList.sort(function (a, b) {
        return a.descr.localeCompare(b.descr, "en", { sensitivity: "base" });
      }),
    [providerList]
  );

  const handleCloseSpinner = () => {
    setOpenLoader(false);
  };

  const handleSubmit = async () => {
    setOpenLoader(true);
    setShowAlert(false);
    if (null == selectedProviderId || _.isEmpty(selectedProviderId) || _.isEqual(selectedProviderId, 0)) {
      handleCloseSpinner();
      toast.error("Please select provider");
      return;
    }

    if (null == selecetdEndDate || _.isEmpty(selecetdEndDate) || _.isEqual(selecetdEndDate, 0)) {
      handleCloseSpinner();
      toast.error("Please select end date");
      return;
    }

    const result = await callEndDateAPI(selectedProviderId, selecetdEndDate);
    log("endDate API response: ", result);
    if (result === null) {
      return;    
    } 

    // load provider data again
    load();
    if (result.httpResponse == 0) {
      // toast.error(result.message);
      setErrorMessage(result.data || []);
      setErrorHeader(result.message);
      setAccessibilityLabel("Warning:");
      setAlertVariant("warning");
      setShowAlert(true);
    } else if (result.httpResponse == 1) {
        // toast.success(result.message);
        setErrorMessage(result.data || []);
        setAccessibilityLabel("Success:");
        setAlertVariant("success"); 
        setErrorHeader(result.message);
        setShowAlert(true);
    }
    
    handleCloseSpinner();
  }

  return (
    <div>
      {openLoader && <LoaderComponent />}
      {!openLoader && (
        <div className="w-[100%]">
          <div className="fileUpload m-[1%] p-[2%] w-[40%] border-2 border-gray-400">
            <Typography variant="h1">Forwarder EndDate</Typography>
            <br/>
            <br/>
              <Row>
                <label className="text-xs pr-[2%]">
                  Forwarder :
                </label>
                <select
                  class="cstm-select focus:outline-none focus:shadow-green-700 focus:shadow-md  text-[0.8rem] block"
                  id="inputGroupSelect01"
                  onChange={(evt) => onProviderChange(evt.target.value)}
                >
                  <option value="" id="" selected>
                    Select Forwarder
                  </option>
                  {pl.map((providerOption) => (
                    <option
                      value={providerOption.providerId}
                      id={providerOption.providerId}
                      key={providerOption.providerId}
                    >
                      {providerOption.descr}
                    </option>
                  ))}
                </select>
              </Row>
            <br/>    
            <Row>
              <label className="text-xs pr-[2%]">
                End Date :
              </label>
              <input
                name="endDate"
                type="date"
                // min={minDate}
                onKeyDown={(e) => e.preventDefault()}
                onChange={(e) => { onDateChange(e); }}
                className="text-xs border-[1px] border-gray-500 rounded-sm p-[3px] w-52"
              />
            </Row>  
            <br/>
            <br/>
            <div className="center p-2">
              <Button
                    id="reportPickup-apply-btn"
                    variant="primary"
                    onClick={() => handleSubmit()}
              >
                Submit
              </Button>
            </div>
          </div>
        </div>
      )}
      {isShowAlert ? (
        <div>
          <Alert
            accessibilityLabel={accessibilityLabel}
            type={alertVariant}
            aria-atomic="true"
            sx={{
              "& .MuiAlert-icon": { fontSize: 25 },
              py: 2,
              px: 6,
            }}
          >
            <AlertTitle>{errorHeader}</AlertTitle>
            <ul className="uxf-alert-description">
              {errorMessage.map((message, index) => (
                <li key={index}>{message}</li>
              ))}
            </ul>
          </Alert>
        </div>
      ) : null}
    </div>
  );
};

export default Provider;
